import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-enetassess',
  templateUrl: './enetassess.component.html',
  styleUrls: ['./enetassess.component.scss']
})
export class EnetassessComponent implements OnInit {

  public logo = "";
  public exisitingLangauge = "en";
  public languageSelected = "en";
  public exams = [];
  public currentExam = 0;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    this.logo = "https://cnavt.org/img/svg/logo.svg";

    const isMock = this.dataSvc.checkMockDetails();
    const enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0) {
      if(isMock !== null && isMock !== undefined){
        generalSvc.logoutMockUser(isMock.MockId);
      }
      else if(dataSvc.assessorExam){
        generalSvc.logoutAssessor();
      }
      else if(dataSvc.anonymousCandidateExam){
        generalSvc.logoutAnonymousCandidate();
      }
      else{
        generalSvc.logoutUser(enetsecure);
      }      
    }

    if (dataSvc.currentUser.Exams.filter(x => x.Completed != true).length == 0){
      if(isMock !== null && isMock !== undefined){
        generalSvc.logoutMockUser(isMock.MockId);
      }
      else{
        generalSvc.logoutUser(enetsecure);
      } 
    }

      this.exisitingLangauge = localStorage.getItem("userslanguage");
      if(this.exisitingLangauge !== null && this.exisitingLangauge !== undefined && this.exisitingLangauge !== ""){
        this.dataSvc.changeLangauge(this.exisitingLangauge);
        this.languageSelected = this.exisitingLangauge;
      }
      else{
        this.translate.setDefaultLang("en");
        this.translate.use("en");
        this.exisitingLangauge = "en";
      }
  }

  ngOnInit() {
    var selLangauge = (<HTMLSelectElement>document.getElementById("selLangauge"));
    if(selLangauge !== null && selLangauge !== undefined){
      selLangauge.value = this.exisitingLangauge.toString();
    }
    this.exams = this.dataSvc.currentUser.Exams; console.log(this.exams);//.filter(x => (x.Completed == null || x.Completed == undefined || !x.Completed) && x.Status < 5);
    for(var exam of this.dataSvc.currentUser.Exams){
      if(exam.Completed == null || exam.Completed == undefined || !exam.Completed && exam.Status < 5){
        let index = this.exams.findIndex(x => x === exam && !x.Session.IsCandidateOralPrep);
        if(index >= 0){
          this.currentExam = index;
          return;
        }
      }

    }
  }

  changeLangauge(language){
    localStorage.setItem("userslanguage", language.toString());
    this.translate.setDefaultLang(language.toString());
    this.translate.use(language.toString());
    this.languageSelected = language.toString();  
  }
  

  launchExam(examIndex) {
    this.dataSvc.currentExamIndex = examIndex;
    this.dataSvc.pulseTimeLog("Start");
    this.generalSvc.launchExam();
  }

  logout(){
    const enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
    localStorage.removeItem("tUsername");
    localStorage.removeItem("tPassword");
    this.generalSvc.logoutUser(enetsecure);
  }
}